<div class="vault-overlay">
  <!-- Backdrop (no click close for security) -->
  <div class="backdrop"></div>

  <!-- Modal -->
  <div class="vault-modal">
    <div class="modal-content">
      <div class="lock-icon">
        <span class="material-symbols-outlined">lock</span>
      </div>

      <div>
        <h2>Unlock Vault</h2>
        <p>Enter your 6-digit PIN to access your secure data.</p>
      </div>

      <form (ngSubmit)="unlock()" class="w-full">
        <div class="pin-input-container">
          <input
            #pinInput
            type="password"
            [(ngModel)]="pin"
            name="pin"
            maxlength="6"
            placeholder="PIN"
            autofocus
            autocomplete="off"
            [disabled]="loading"
          />
        </div>

        <div class="error-msg">
          <ng-container *ngIf="error">
            <span class="material-symbols-outlined">error</span>
            <span>{{ error }}</span>
          </ng-container>
        </div>

        <button
          type="submit"
          class="btn-large-brand"
          [disabled]="loading || pin.length < 6"
        >
          <span *ngIf="loading" class="material-symbols-outlined animate-spin"
            >progress_activity</span
          >
          <span>{{ loading ? "Unlocking..." : "Unlock Vault" }}</span>
        </button>
      </form>
    </div>
  </div>
</div>
